import React, { useEffect } from 'react';
import q from '../../assets/images/q1.png';
import { makeStyles, Box, Grid } from '@material-ui/core';
import p1 from '../../assets/images/p-1.jpg';
import p2 from '../../assets/images/p-2.jpg';
import p3 from '../../assets/images/p-3.jpg';
import p4 from '../../assets/images/p-4.jpg';
import p5 from '../../assets/images/p-5.jpg';
import p6 from '../../assets/images/p-6.jpg';
import '../home.css';
import SearchFlight from '../../form/SearchFlight';
// import ima from '../../assets/images/ima.jpg';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import OurPackageCard from '../../components/reusableComponents/OurPackageCard';
import OurServiceSection from '../../components/reusableComponents/OurServiceSection';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
import {
	agentlogogetDispatch,
	walletBalanceAgentDispatch,
} from '../../reducers/UserReducer';
import LoaderModal from '../../components/reusableComponents/LoaderModal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { searchSuccess, searchSuccessEtrav } from '../../reducers/HomeReducer';
import { toggleBPNRModal } from '../../reducers/UiReducer';
import Footer from './Footer';
const useStyles = makeStyles((theme) => ({
	back: {
		backgroundImage: `url(https://nitish.musafirbazar.com/static/back.jpg)`,
		height: 1189,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '1px -40px',
		position: 'relative',
		[theme.breakpoints.up('lg')]: {
			height: 494,
		},
		[theme.breakpoints.down('xs')]: {
			height: 805,
		},
	},
}));
const data = [
	{
		title: 'Mumbai',
		image: p1,
		price: '₹22999',
		discount: '₹18999',
		desc: 'The mega-glamorous capital city of Maharashtra. Mumbai Tour Packages introduce visitors to the mega-city snuggled along the Arabian Sea, driven by power, wealth, glamour and fame. The megapolis is thriving with dreams and aspirations.',
	},
	{
		title: 'Hawaii',
		image: p2,
		price: '₹145999',
		discount: '₹136999',
		desc: 'The perfect example of an island paradise, Hawaii stands out for its beautiful landscapes, gorgeous beaches and a vibrant culture. Situated in the Central Pacific Ocean, Hawaii is a group of volcanic islands, visited by millions of tourists every year',
	},
	{
		title: 'Sydney',
		image: p3,
		price: '₹95999',
		discount: '₹85999',
		desc: 'Sydney, the capital of New South Wales in Australia, is one of the oldest and largest cities in the country that has a multicultural outlook. Famous for the iconic landmarks like Sydney Harbour Bridge and Sydney Opera House, this place is simply worth a visit.',
	},
	{
		title: 'Paris',
		image: p4,
		price: '₹155999',
		discount: '₹145999 ',
		desc: 'Paris, the stylish French capital, conjures up images of monument-lined boulevards, waterside boutiques and bistros, museums, art galleries, eclectic wine bars, reading cafes, designer outlets, primly manicured gardens, and the ubiquitous Eiffel Tower.',
	},
	{
		title: 'Tokyo',
		image: p5,
		price: '₹65999',
		discount: '₹55999 ',
		desc: 'Tokyo is in the Kanto region of Japan on the south coast of the main island and is the country capital city. It is a foodie"s paradise, haven of pop culture, and has the highest urban population in the world with nearly 38 million people living in Tokyo alone.',
	},
	{
		title: 'Egypt',
		image: p6,
		price: '₹95999',
		discount: '₹82999 ',
		desc: 'Egypt strategic location in the northeast of Africa with the Mediterranean Sea to its north, the Red Sea, the Gulf of Suez and the Gulf of Aqaba to its east and an eastern portion, the Sinai Peninsula, falling in Western Asia .',
	},
];
const dataService = [
	{
		id: 1,
		title: 'Affordable Hotels Booking',
		fontawesomeIcon: 'fas fa-hotel',
		desc: 'We offer the easiest hotel reservation services for you to take advantage of. Avail the best prices and check out accurate hotel listings in India and abroad & hotel listings in India and abroad',
	},
	{
		id: 2,
		title: 'Fastest Travel Booking',
		fontawesomeIcon: 'fas fa-plane',
		desc: 'Book Your Flight And Train Tickets Online Without Going Through Any Hassle. Check Availability Of Seats, Schedule And Compare Fares For Both Domestic As Well As Foreign Travel.',
	},
	{
		id: 3,
		title: 'Bus Booking',
		fontawesomeIcon: 'fas fa-bus',
		desc: 'A bus reservation system is a mobile or web software solution designed to provide customers with a personalized easy-to-utilize user experience for booking and purchasing tickets online.',
	},

	{
		id: 4,
		title: 'Car Booking',
		fontawesomeIcon: 'fas fa-car',
		desc: 'Our car rental system is a web-based booking system intended to meet the particular needs of car rental organizations, travel consolidators,travel consolidators and travel agents. ',
	},
	{
		id: 5,
		title: 'New adventures',
		fontawesomeIcon: 'fas fa-hiking',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
	{
		id: 6,
		title: 'Holiday Package',
		fontawesomeIcon: 'fas fa-globe',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
];
function HomePage() {
	const classes = useStyles();
	const { loadinguser, agentlogin } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const history = useHistory();

	window.onscroll = () => {
		let loginForm = document.querySelector('.login-form');
		let navbar = document.querySelector('.navbar');
		navbar.classList.remove('active');
		loginForm.classList.remove('active');
	};
	// useEffect(() => {
	// 	localStorage.clear()
	//   }, []);
	// console.log('invoice', invoice);
	useEffect(() => {
		if (agentlogin && agentlogin.status === 200) {
			let logodata = {
				agent_id: agentlogin && agentlogin.result.result.id,
			};
			dispatch(agentlogogetDispatch(logodata));
			// let walletform = {
			// 	userEmail: agentlogin && agentlogin.result.result.email,
			// 	userId: ,
			// };
			dispatch(
				walletBalanceAgentDispatch(
					agentlogin && agentlogin.result.result.email,
					agentlogin && agentlogin.result.result.id
				)
			);
		}
		dispatch(searchSuccess(null));
		dispatch(searchSuccessEtrav(null));
		dispatch(toggleBPNRModal(false));
	}, [dispatch]);
	return (
		<>
			<HeaderSection id={1} />
			<section
				onClick={() => {
					let loginForm = document.querySelector('.login-form');
					let navbar = document.querySelector('.navbar');
					navbar.classList.remove('active');
					loginForm.classList.remove('active');
				}}
				className={`'form-container' ${classes.back}`}
				data-aos='zoom-in'>
				<SearchFlight />
			</section>

			<section className='home' id='home'>
				<div className='image'>
					<img src={q} alt='q' />
				</div>

				<div className='content'>
					<h3 style={{ color: 'rgb(239, 51, 57)', fontSize: 30 }}>
						Why book with Click N BOOK?
						{/* Why book with Suzu Travel.com? */}
						{/* Why book with Jupiter Yatra? */}
						{/* Why book with World Wide Sales? */}
						{/* Why book with Musafir Bazar? */}
					</h3>
					{/* <h3 style={{ color: 'rgb(239, 51, 57)' }}>
						Why book with MusafirBazar.com?
					</h3> */}
					<p
						style={{
							color: 'black',
							fontFamily: 'Poppins, sans-serif',
							fontSize: 14,
						}}>
						"Make the most of yourself by fanning the tiny, inner sparks of
						possibility into flames of achievement"
					</p>
					<a href='#' className='btn' style={{ borderRadius: 10,fontSize:16 }}>
						Explore Now
					</a>
				</div>
			</section>

			<section className='packages' id='packages'>
				<h1
					className='heading'
					style={{ fontFamily: 'unset', textAlign: 'left', fontSize: 36 }}>
					Travel <span>Destination</span>
				</h1>

				<div className='box-container'>
					<Grid container spacing={2}>
						{data.map((item, index) => {
							return <OurPackageCard item={item} index={index} />;
						})}
					</Grid>
				</div>
			</section>

			<section className='services' id='services'>
				<h1 className='heading' style={{ fontSize: 36 }}>
					We <span>Deals In</span>
				</h1>

				<div className='box-container'>
					<Grid container spacing={2}>
						{dataService.map((item, index) => {
							return <OurServiceSection item={item} index={index} />;
						})}
					</Grid>
				</div>
			</section>

			<section className='footer'>
				{/* <div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>Click N Book</h3>
						<a
							onClick={() => history.push('/aboutus')}
							style={{ cursor: 'pointer' }}>
							<i className='fas fa-chevron-right'></i> Company Info
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Privacy Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Terms & Condition
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Careers
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i>
							About Us
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Products</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Flight Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Bus Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Hotel Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Holiday Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Car Booking
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Contact Info</h3>
						<a href='#'>
							<i className='fas fa-phone'></i> +91 7007102425
						</a>
						<a href='#'>
							<i className='fas fa-envelope'></i> info@clicknbook.in
						</a>
						
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Follow Us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							<i className='fab fa-facebook-f'></i> facebook
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							<i className='fab fa-twitter'></i> twitter
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							<i className='fab fa-instagram'></i> instagram
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							<i className='fab fa-linkedin'></i> linkedin
						</a>
						<a href='#'>
							<i className='fab fa-pinterest'></i> pinterest
						</a>
					</div>
				</div> */}
				<Grid container style={{ textAlign: 'center' }}>
					<Grid item xs={12} sm={4} md={4} lg={4}>
						<a href='#'>
							{/* <i className='fas fa-phone'></i> +91 7607434688 */}
							{/* <i className='fas fa-phone'></i> +91 7862919191 */}
							{/* <i className='fas fa-phone'></i> +91 7007102425 */}
							{/* <i className='fas fa-phone'></i> +91 8219552695 */}
						</a>
					</Grid>
					<Grid item xs={12} sm={4} md={4} lg={4}>
						<a href='#'>
							{/* <i className='fas fa-envelope'></i>support@jupiteryatra.in */}
							{/* <i className='fas fa-envelope'></i>worldwidesales@gmail.com */}
							{/* <i className='fas fa-envelope'></i>info@suzutravels.com */}
							{/* <i className='fas fa-envelope'></i>info@clicknbook.in */}
						</a>
					</Grid>
					<Grid item xs={12} sm={4} md={4} lg={4}>
						<a href='#'>
							<i className='fas fa-map-marker-alt'></i>
							{/* Branch1- NH-103, Roadside, Ghumarwin, Bilaspur, H.P */}
						</a>
					</Grid>
				</Grid>
				{/* <div className='credit' style={{ fontSize: 14 }}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation India
					Pvt. Ltd.
				</div> */}
			</section>
			<ErrorModal />
			<Footer/>
			{loadinguser ? <LoaderModal /> : ''}
		</>
	);
}

export default HomePage;
